export const isSubQuestAvailable = (subQuest) => {
  if (subQuest.isPublished !== undefined) {
    return subQuest.isPublished === true;
  }

  if (subQuest.status) {
    return subQuest.status === 'Published' || subQuest.status === 'published';
  }

  if (subQuest.isDraft !== undefined) {
    return subQuest.isDraft === false;
  }

  return true;
};

export const findNextSubQuest = (quests, currentQuestId, currentSubQuestId) => {
  // Find current quest
  const currentQuest = quests.find((quest) => quest.id === currentQuestId);
  if (!currentQuest || !currentQuest.subQuests) return null;

  // Find current sub-quest index
  const currentSubQuestIndex = currentQuest.subQuests.findIndex(
    (subQuest) => subQuest.id === currentSubQuestId
  );

  if (currentSubQuestIndex === -1) return null;

  // Look for next available sub-quest in current quest
  for (
    let i = currentSubQuestIndex + 1;
    i < currentQuest.subQuests.length;
    i += 1
  ) {
    const subQuest = currentQuest.subQuests[i];
    if (isSubQuestAvailable(subQuest)) {
      return {
        questId: currentQuest.id,
        subQuestId: subQuest.id,
        subQuest,
        quest: currentQuest,
      };
    }
  }

  // Look for next quest with available sub-quests
  const currentQuestIndex = quests.findIndex(
    (quest) => quest.id === currentQuestId
  );
  for (let i = currentQuestIndex + 1; i < quests.length; i += 1) {
    const quest = quests[i];
    if (quest.subQuests && quest.subQuests.length > 0) {
      for (let j = 0; j < quest.subQuests.length; j += 1) {
        const subQuest = quest.subQuests[j];
        if (isSubQuestAvailable(subQuest)) {
          return {
            questId: quest.id,
            subQuestId: subQuest.id,
            subQuest,
            quest,
          };
        }
      }
    }
  }

  return null;
};

export const buildSubQuestNavigationUrl = (
  courseId,
  questId,
  subQuestId,
  classId = null
) => {
  const baseUrl = classId
    ? `/classes/${classId}/courses/${courseId}/quests/${questId}/sub-quests/${subQuestId}`
    : `/courses/${courseId}/quests/${questId}/sub-quests/${subQuestId}`;
  return baseUrl;
};

export const isAutoPlayEnabled = () => {
  const autoPlayPreference = localStorage.getItem('subquest-autoplay');
  return autoPlayPreference !== 'false';
};

export const setAutoPlayPreference = (enabled) => {
  localStorage.setItem('subquest-autoplay', enabled.toString());
};
